import { Appl } from "../../../core/Appl";
import { ReleaseNoteService } from "./ReleaseNoteService";
import ReleaseNotesViewModel from "./note/ReleaseNotesViewModel";

export default class ReleaseNoteModule {
    public static init(): void {
        Appl.Services.add('IReleaseNoteService', ReleaseNoteService);
        Appl.Services.add('ReleaseNotesViewModel', ReleaseNotesViewModel);
    }
}